import { render, staticRenderFns } from "./FileImageComponent.vue?vue&type=template&id=3b6c4ef1&"
import script from "./FileImageComponent.vue?vue&type=script&lang=js&"
export * from "./FileImageComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports